import _ from 'lodash'

const isReady = (state) => !_.isUndefined(state.ready)
const isShowAlert = (state) => _.get(state, 'isShowAlert')
const alertMessage = (state) => _.get(state, 'alertMessage')
const alertType = (state) => _.get(state, 'alertType')
const closeTimeout = (state) => _.get(state, 'closeTimeout')
const sessionId = (state) => _.get(state, 'session_id')
const getSearchMethods = (state) => state.searching
const getSearchText = (state) => state.searchText


export default {
	isReady,
	isShowAlert,
	alertMessage,
	alertType,
	closeTimeout,
	sessionId,
	getSearchMethods,
	getSearchText
}
